import React from "react";

const mruganksha_kudake = () => {
  return (
    <div>
      <h1>Mruganksha Kudake</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        1. Students with 8.0+ CGPA were eligible.
        <br />
        2. Only Computer Science students were considered.
        <br />
        3. An aptitude test was conducted.
        <br />
        4. Highest Test Scores with least amount of time were shortlisted for
        next round.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        Timeline of the Entire Interview Process:
      </p>

      <ol>
        <li>
          <strong>Round 1 – Aptitude Test:</strong> Conducted online as the
          first stage of the process.{" "}
        </li>
        <li>
          <strong>After one Day</strong> Pre-Placement Talk (PPT): Held in the
          morning, where company details and role expectations were shared.{" "}
        </li>
        <li>
          <strong>Shortlisting Announcement:</strong> Immediately after the PPT,
          results of the aptitude test were declared 19 students were
          shortlisted for interviews.{" "}
        </li>
        <li>
          <strong>Technical Interview:</strong> Conducted on the same day,
          starting within half an hour of the announcement.{" "}
        </li>
        <li>
          <strong>HR Interview:</strong> Followed immediately after the
          technical round, for those shortlisted from the technical round.{" "}
        </li>
        <li>
          <strong>Final Result:</strong> Announced the same day, with 6 students
          receiving the offer letters.
        </li>
      </ol>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round consisted of three sections:
      </p>

      <ol>
        <li>
          <strong>Logical, Mathematical, and CS Concepts:</strong>
          <ul>
            <li>
              10 questions covering logical reasoning, quantitative aptitude,
              OOPs, and DSA basics.{" "}
            </li>
          </ul>
        </li>
        <li>
          <strong>Coding Section:</strong>
          <ul>
            <li>3 DSA questions in total. </li>
            <li>First 2 questions: Simple coding problems. </li>
            <li>
              Third question: Slightly difficult, focused on dynamic
              programming.{" "}
            </li>
          </ul>
        </li>
        <li>
          <strong>SQL Section:</strong>
          <ul>
            <li>3 SQL queries in total. </li>
            <li>First 2 queries: Easy, testing basic SQL operations. </li>
            <li>
              Third query: Moderate difficulty, focused on GROUP BY, filtering,
              and JOIN operations.
            </li>
          </ul>
        </li>
      </ol>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        19 students were shortlisted for the interview round based on their
        performance in the aptitude test.
        <br />
        Out of these, 6 students finally received the offer.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The aptitude test was conducted on 6th August, and the interviews were
        scheduled on 8th August.
        <br />
        However, the shortlisted candidates were announced only a few minutes
        before the interviews, so there was no extra time on the day of the
        interviews.
        <br />I had already prepared in advance after the test:
      </p>

      <ol>
        <li>OOPs Concepts: Brushed up using GeeksforGeeks. </li>
        <li>
          DSA: Solved a few questions to revise problem-solving logic and
          reviewed my DSA notes.{" "}
        </li>
        <li>
          DBMS<strong>:</strong> Revised from Love Babbar notes.{" "}
        </li>
        <li>
          Projects: Reviewed all projects mentioned in my resume and anticipated
          the most likely questions.{" "}
        </li>
        <li>
          HR Round: Prepared strategies to answer negative situations positively
          and practiced common behavioral questions.{" "}
        </li>
      </ol>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        The company conducted <strong>2 interview rounds</strong>:
      </p>

      <ol>
        <li>
          <strong>Technical Round:</strong>The interview began with questions
          from my resume. They discussed my Invoice Management System project,
          asking about its working, database handling, authentication process,
          and concepts related to Node.js, React, and HTTP status codes. They
          then moved to my File and Image Compressor-Decompressor project,
          focusing on the data structures used, especially the Quadtree for
          image compression. I was also given two debugging questions, followed
          by conceptual OOPs questions on the five pillars. A scenario was given
          where I had to design classes and objects to demonstrate abstraction
          and inheritance. Lastly, a DBMS scenario related to a shopping system
          was asked, where I created a table and wrote two queries. This round
          lasted for about 40–50 minutes.{" "}
        </li>
        <li>
          <strong>HR Round:</strong> The HR Round was quite friendly and
          conversational. The interviewer asked situational and personal
          questions like my worst day, best achievements, favorite teacher, how
          teachers would rate me, and my negative points. Toward the end, I was
          asked if I had any questions, to which I inquired about the projects
          handled by previous interns and the training and work process at
          Pattern Technologies. Finally, 6 students received the offer.
        </li>
      </ol>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        <strong>DSA:</strong> It was the most important area. They asked several
        questions related to the data structures used in my projects, so having
        a clear understanding of the logic, implementation, and purpose behind
        each data structure was crucial. It’s important to not just memorize
        algorithms but to understand how and why a particular structure was used
        in your project.
        <br />
        <strong>OOPD:</strong> A strong grasp of the basics helped a lot. Most
        of the questions revolved around the core principles of Object-Oriented
        Programming, like abstraction, inheritance, encapsulation, and
        polymorphism. Since these concepts are covered well in academics, a
        quick brush-up before the interview was enough to confidently answer
        those questions.
        <br />
        <strong>DBMS</strong>: It was not deeply covered in our semester at that
        time, so I prepared it separately by following Love Babbar’s internship
        preparation series. His DBMS notes were extremely helpful, which helped
        me tackle scenario-based questions effectively.
      </p>

      <p>
        Overall, the interviewers focused on conceptual clarity, project
        understanding, and practical application of technical knowledge.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Strivers SDE Sheet and Leetcode: Coding Questions and DSA
        <br />
        DBMS: CodeHelp by Babbar’s placement series
        <br />
        OPPS: Geeks for geeks
        <br />
        Puzzles: Geeks for geeks
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        To crack coding questions effectively, it’s best to practice DSA
        problems topic-wise to build strong fundamentals. I found Striver’s DSA
        Sheet very helpful, as it includes questions of varying difficulty
        levels easy, medium, and hard which gradually improve problem-solving
        skills. While solving any question, always begin with the brute-force
        approach to understand the basic logic, and then work on optimizing it
        for better efficiency. It’s also important to revisit the difficult
        questions after some time and try solving them again without referring
        to the solutions, as this helps reinforce concepts and improve
        retention.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?
      </p>

      <p>
        A significant number of questions were asked about my projects, and the
        interviewers went into considerable depth while discussing them. It’s
        very important to know your projects inside out, including the concepts,
        tools, and data structures used, as well as how you could improve or
        scale them further.
      </p>

      <p>
        Additionally, a few questions were asked about my extracurricular
        activities. One of them was based on my role as the Finance Coordinator
        at Reggatta, where I was given a scenario-based question related to
        handling a deal.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        For this company, focus strongly on OOPs and DBMS concepts, as they are
        key areas of evaluation. While answering, try to give examples to show
        practical understanding. Stay confident and composed during the HR
        round, as communication and body language matter. Be open to feedback
        and suggestions, and make sure to understand the company’s values so you
        can reflect them naturally in your answers.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        The interview process can sometimes feel tough and exhausting,
        especially when balanced with academics, but it’s important to believe
        in yourself and stay confident. Self-confidence plays a huge role if
        you’ve worked hard sincerely, success will definitely follow. Keep
        putting in consistent effort, stay sincere, and make sure to grab every
        opportunity at the right time.
        <br />
        <strong>All the best!!</strong>
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 7798971100
        <br />
        <strong>Email :</strong> <a href="mailto:kudakemv23.comp@coeptech.ac.in">kudakemv23.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/mruganksha-kudake-877400291">
          Mruganksha Kudake
        </a>
      </p>
    </div>
  );
};

export default mruganksha_kudake;
